
export function tooltipInit() {
    /**
     * Tooltips
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    const tooltipList = tooltipTriggerList.map(async (tooltipTriggerEl) => {
        let {default: Tooltip} = await import('bootstrap/js/dist/tooltip');
        return new Tooltip(tooltipTriggerEl);
    });
}
 